import { FC, useEffect, useState } from 'react';
import forEach from 'lodash/forEach';
import Pusher from 'pusher-js';

import { isAuthenticatedUserSelector, userDataSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { bindWithChunking, pusherOptions } from 'utils/pusher/pusherHelpers';
import { pusherReducer } from 'utils/pusher/pusherReducer';
import { EPusherEvents, EPusherSystemEvents } from 'utils/pusher/pusherTypes';
import { STORAGE_KEYS } from 'utils/constants/constants';

const withPusher = (Component: FC) => (props: any) => {
  const isAuthenticated = useTypedSelector(isAuthenticatedUserSelector);
  const userData = useTypedSelector(userDataSelector);
  const userSelection = localStorage.getItem(STORAGE_KEYS.userSelection);

  const [pusher, setPusher] = useState<any>();

  const handlePusher = () => {
    if (isAuthenticated) {
      setPusher(new Pusher(process.env.REACT_APP_PUSHER_APP_KEY!, pusherOptions));
    } else {
      setPusher(undefined);
      pusher?.disconnect();
    }
  };

  const handleSubscribePusher = () => {
    if (pusher) {
      const user = userSelection ? JSON.parse(userSelection) : userData;
      //  TODO ARTEM change chanel to private after Backend authorizer
      //   const channel = pusher.subscribe(`private-${userData.cognitoUsername}`);
      const channel = pusher.subscribe(user.cognitoUsername);

      forEach(Object.values(EPusherSystemEvents), (event) =>
        pusher.connection.bind(event, (data: any) => pusherReducer({ data, event })));
      forEach(Object.values(EPusherEvents), (event) =>
        bindWithChunking(channel, event, (data: any) => pusherReducer({ data, event })));
    }
  };

  useEffect(() => {
    handlePusher();
  }, [isAuthenticated]);

  useEffect(() => {
    handleSubscribePusher();
  }, [pusher]);

  return <Component {...props} />;
};

export default withPusher;
